import { Email } from "./emailTypes";

/**
 * Returns total unread inbox mails
 */
export function getUnreadMails(mails: Email[]) {
	return mails.filter((mail) => !mail.isRead && mail.category === "inbox");
}
